import { useState } from 'react';
import { MapButton, Modal } from '@/shared/ui';

type NavigationApp = 'tmap' | 'kakao' | 'naver';

const APP_LABELS: Record<NavigationApp, string> = {
	tmap: '티맵',
	kakao: '카카오 네비',
	naver: '네이버 지도',
};

type NavigationButtonGroupProps = {
	onNavigate: (app: NavigationApp) => void;
};

const NavigationButtonGroup = ({ onNavigate }: NavigationButtonGroupProps) => {
	const [pendingApp, setPendingApp] = useState<NavigationApp | null>(null);

	const handleButtonClick = (app: NavigationApp) => {
		setPendingApp(app);
	};

	const handleConfirm = () => {
		if (pendingApp) {
			onNavigate(pendingApp);
		}
		setPendingApp(null);
	};

	const handleClose = () => {
		setPendingApp(null);
	};

	return (
		<>
			<div className="flex gap-3 self-stretch">
				<MapButton
					type="tmap"
					className="flex-1"
					onClick={() => handleButtonClick('tmap')}
				/>
				<MapButton
					type="kakao"
					className="flex-1"
					onClick={() => handleButtonClick('kakao')}
				/>
				<MapButton
					type="naver"
					className="flex-1"
					onClick={() => handleButtonClick('naver')}
				/>
			</div>
			<Modal
				isOpen={!!pendingApp}
				onClose={handleClose}
				title={pendingApp ? APP_LABELS[pendingApp] : ''}
				primaryAction={{ label: '앱 열기', onClick: handleConfirm }}
				secondaryAction={{ label: '닫기', onClick: handleClose }}
			>
				모바일 기기에서만 이용할 수 있는 기능이에요
			</Modal>
		</>
	);
};

export default NavigationButtonGroup;
